/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleBasicERC20Token__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleBasicERC20Token__factory.bytecode = _bytecode;
ExampleBasicERC20Token__factory.abi = _abi;
//# sourceMappingURL=ExampleBasicERC20Token__factory.js.map